import { render, staticRenderFns } from "./flow-box.vue?vue&type=template&id=2c2dfdaa&"
import script from "./flow-box.vue?vue&type=script&lang=ts&"
export * from "./flow-box.vue?vue&type=script&lang=ts&"
import style0 from "./flow-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports